export const VER_IFileAttachWibMessageContent = 1

export interface IFileAttachWibMessageContent {
    fileName: string
    downloadUrl: string
    version: number
}